const NAMESPACE = 'WALLET';

// Wallet import
export const WALLET_IMPORT_REQ = `${NAMESPACE}/WALLET_IMPORT_REQ`;

// Wallet generation
export const WALLET_GENERATE_REQ = `${NAMESPACE}/WALLET_GENERATE_REQ`;
export const WALLET_GENERATE_OK = `${NAMESPACE}/WALLET_GENERATE_OK`;
export const WALLET_GENERATE_FAIL = `${NAMESPACE}/WALLET_GENERATE_FAIL`;
export const WALLET_GENERATE_CURR_BLOCK = `${NAMESPACE}/WALLET_GENERATE_CURR_BLOCK`;
export const WALLET_RESET_ERROR = `${NAMESPACE}/WALLET_RESET_ERROR`;

// Creation steps control
export const WALLET_STEPS_NEXT = `${NAMESPACE}/WALLET_STEPS_NEXT`;

// Wallet registration inside the Address Book smart contract
export const WALLET_REGISTER_REQ = `${NAMESPACE}/WALLET_REGISTER_REQ`;
export const WALLET_REGISTER_OK = `${NAMESPACE}/WALLET_REGISTER_OK`;
export const WALLET_REGISTER_FAIL = `${NAMESPACE}/WALLET_REGISTER_FAIL`;
export const WALLET_REGISTER_TX_CONFIRM = `${NAMESPACE}/WALLET_REGISTER_TX_CONFIRM`;
export const WALLET_REGISTER_TX_FAIL = `${NAMESPACE}/WALLET_REGISTER_TX_FAIL`;

// Retrieve the list of registered users
export const ADDRESSBOOK_FETCH_REQ = `${NAMESPACE}/ADDRESSBOOK_FETCH_REQ`;
export const ADDRESSBOOK_FETCH_OK = `${NAMESPACE}/ADDRESSBOOK_FETCH_OK`;
export const ADDRESSBOOK_FETCH_FAIL = `${NAMESPACE}/ADDRESSBOOK_FETCH_FAIL`;

// New wallet from subscription
export const NEW_REGISTRATION_EVENT = `${NAMESPACE}/NEW_REGISTRATION_EVENT`;

// Balance change
export const BALANCE_UPDATE_REQ = `${NAMESPACE}/BALANCE_UPDATE_REQ`;
export const BALANCE_UPDATE_OK = `${NAMESPACE}/BALANCE_UPDATE_OK`;
export const BALANCE_UPDATE_FAIL = `${NAMESPACE}/BALANCE_UPDATE_FAIL`;
